import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface VanBalanceState {
  /** Display balance for navbar VAN control (same currency as `currency`). */
  balance: number;
  currency: string;
}

const initialState: VanBalanceState = {
  balance: 6736842.00,
  currency: 'DJF',
};

export const vanBalanceSlice = createSlice({
  name: 'vanBalance',
  initialState,
  reducers: {
    setVanBalance: (
      state,
      action: PayloadAction<{ balance: number; currency?: string }>
    ) => {
      state.balance = action.payload.balance;
      if (action.payload.currency != null) {
        state.currency = action.payload.currency;
      }
    },
    /** Subtract successful BlPayment payable amount (VAN Payment flow). */
    subtractVanPayableAmount: (state, action: PayloadAction<number>) => {
      const amt = Number(action.payload);
      if (!Number.isFinite(amt) || amt <= 0) return;
      state.balance = Math.max(0, state.balance - amt);
    },
    /** Add amount credited via VAN Account modal (top-up). */
    addVanCreditAmount: (state, action: PayloadAction<number>) => {
      const amt = Number(action.payload);
      if (!Number.isFinite(amt) || amt <= 0) return;
      state.balance = state.balance + amt;
    },
    resetVanBalance: () => ({ ...initialState }),
  },
});

export const {
  setVanBalance,
  subtractVanPayableAmount,
  addVanCreditAmount,
  resetVanBalance,
} = vanBalanceSlice.actions;

export default vanBalanceSlice.reducer;
